import Modal from './modal';
export type { ModalProps } from './modal';

export default Modal;
